import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/apiConfig';
import './AccountLogin.css';

const AccountLogin = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    const savedUsername = localStorage.getItem('saved_username');
    const savedPassword = localStorage.getItem('saved_password');
    const rememberPwd = localStorage.getItem('remember_password') === 'true';

    if (savedUsername) {
      form.setFieldsValue({ username: savedUsername });
    }
    if (rememberPwd && savedPassword) {
      form.setFieldsValue({ password: savedPassword, rememberMe: true });
    }

    // 如果已有有效 token，直接跳转
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/login');
    }
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const { username, password, rememberMe } = values;
      const url = `${API_BASE_URL}/api/auth/login`;

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.code !== 200) {
        message.error(data.msg || '操作失败');
        return;
      }

      // 保存 token 和用户信息
      localStorage.setItem('token', data.data.token);
      localStorage.setItem('user_info', JSON.stringify(data.data.user));
      localStorage.setItem('saved_username', username);
      localStorage.setItem('account_logged_in', 'true');

      if (rememberMe) {
        localStorage.setItem('saved_password', password);
        localStorage.setItem('remember_password', 'true');
      } else {
        localStorage.removeItem('saved_password');
        localStorage.setItem('remember_password', 'false');
      }

      message.success('登录成功');
      navigate('/login');
    } catch (error) {
      console.error('操作失败:', error);
      message.error('网络错误，请检查网络连接');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-login-container">
      <div className="account-login-background">
        <div className="account-login-content">
          <Card className="account-login-card">
            <div className="account-login-header">
              <h1>大鱼同步课堂</h1>
              <p>支持大鱼账号或教师手机号登录</p>
            </div>

            <Form
              form={form}
              name="account-login"
              size="large"
              onFinish={handleSubmit}
              layout="vertical"
            >
              <Form.Item
                name="username"
                label="账号"
                rules={[{ required: true, message: '请输入账号' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="手机号／账号" />
              </Form.Item>

              <Form.Item
                name="password"
                label="密码"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, max: 32, message: '密码长度6-32位' },
                ]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="输入密码" />
              </Form.Item>

              <Form.Item name="rememberMe" valuePropName="checked">
                <Checkbox>记住密码</Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="account-login-button"
                  loading={loading}
                  block
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AccountLogin;
